"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = exports.encrypt = exports.getNonce = void 0;
const tweetnacl_1 = require("tweetnacl");
const anchor = __importStar(require("@project-serum/anchor"));
const ed2curve_1 = require("ed2curve");
const bytes_1 = require("@project-serum/anchor/dist/cjs/utils/bytes");
function getNonce() {
    return (0, tweetnacl_1.randomBytes)(tweetnacl_1.box.nonceLength);
}
exports.getNonce = getNonce;
function encrypt(message, nonce, publicKey_receiver, privateKey_sender) {
    const curve25519PrivateKey_sender = (0, ed2curve_1.convertSecretKey)(privateKey_sender);
    const curve25519PublicKey_receiver = (0, ed2curve_1.convertPublicKey)(anchor.utils.bytes.bs58.decode(publicKey_receiver.toBase58()));
    if (!curve25519PublicKey_receiver) {
        throw new Error(`Error conver publickey`);
    }
    const messageUint8 = Buffer.from(message);
    const encrypted = (0, tweetnacl_1.box)(messageUint8, nonce, curve25519PublicKey_receiver, curve25519PrivateKey_sender);
    return bytes_1.bs58.encode(encrypted);
}
exports.encrypt = encrypt;
function decrypt(encrypted, nonce, publicKey_sender, privateKey_receiver) {
    const curve25519PrivateKey_receiver = (0, ed2curve_1.convertSecretKey)(privateKey_receiver);
    const curve25519PublicKey_sender = (0, ed2curve_1.convertPublicKey)(anchor.utils.bytes.bs58.decode(publicKey_sender.toBase58()));
    if (!curve25519PublicKey_sender) {
        throw new Error(`Error conver publickey`);
    }
    const nonceUint8 = Uint8Array.from(bytes_1.bs58.decode(nonce));
    const encodedEncryptedData = bytes_1.bs58.decode(encrypted);
    const decrypted = tweetnacl_1.box.open(encodedEncryptedData, nonceUint8, curve25519PublicKey_sender, curve25519PrivateKey_receiver);
    if (!decrypted) {
        throw new Error(`Error decrypt data`);
    }
    return Buffer.from(decrypted).toString();
}
exports.decrypt = decrypt;
